export default __webpack_public_path__ + "static/media/goa.b6f4e45e.jpg";